<template>
  <div class="text-xs-center pt-2 pb-2">
    <v-pagination
        v-model="pagination.current"
        :page="pagination.current"
        :length="pagination.total"
        :total-visible="7"
        @input="action">
    </v-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['pagination', 'action'],
};
</script>
